export default __webpack_public_path__ + "static/media/chittra.e10c8ddd.jpg";